/**
 * UIKit Index
 *
 * Entry point for initializing and exporting UIKit components, directives,
 * and utilities. This file acts as the central import/export hub.
 *
 * Usage:
 *   <div x-uikit="card"></div>
 */

// Import all available uikit modules here
import card from "./modules/card.js"

// modules registry
const modules = {
  card
}

export default function uikit(Alpine) {
  Alpine.directive("uikit", (el, { expression }) => {
    const module = modules[expression]
    if (typeof module === "function") {
      module(el, Alpine);
    } else {
      console.warn(`UIKit directive module "${expression}" not found.`)
    }
  })
}